module.exports = __webpack_public_path__ + "img/icon-close-red-light.b6d0a99e.svg";